module.exports = __webpack_public_path__ + "7874f913fc017f11419c5b0afc44166d.svg";